module.exports = __webpack_public_path__ + "img/azul.34dff45f.svg";